// extracted by mini-css-extract-plugin
export var content = "SplitViewLargeTextImageRight-module--content--61273";
export var groupContent = "SplitViewLargeTextImageRight-module--groupContent--fe64c";
export var heading = "SplitViewLargeTextImageRight-module--heading--0c003";
export var image = "SplitViewLargeTextImageRight-module--image--89737";
export var moreInfo = "SplitViewLargeTextImageRight-module--moreInfo--4f11a";
export var wrapper = "SplitViewLargeTextImageRight-module--wrapper--0aa8b";